import { Component } from '@angular/core';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { NotificationGridComponent } from '../notificationgrid.component';

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message-history-grid',
    templateUrl: './push-message-history-grid.component.html',
    styleUrls: ['./push-message-history-grid.component.scss']
})
export class PushMessageHistoryGridComponent extends NotificationGridComponent {

    constructor(A: ServiceBagService) {
        super(A, 'PushMessageHistoryGridComponent');
    }
}
